<template>
  <section v-if="items.length" class="mb-4 sm:mb-8 lg:mb-10">
    <div class="container z-grid v-page-section-container-padding">
      <div class="col-span-full 2xl:col-start-2 2xl:col-end-12 sm:flex flex-row items-center justify-between leading-none mb-4 sm:mb-6">
        <h2
          v-if="title"
          class="flex-auto font-semibold leading-tight text-2xl md:text-3xl mb-4 md:mb-6"
          :class="{
            'text-white': colorTheme === 'dark-green' || colorTheme === 'petrol' || colorTheme === 'red',
            'text-app-primary-1-red--torch': colorTheme === 'blue' || colorTheme === 'light-green',
            'text-app-primary-1-red--fire-brick': colorTheme === 'pink',
          }"
        >
          {{ title }}
        </h2>
        <MoleculeButton :url="buttonUrl" :enable-icon-left="false" size="small" class="md:hidden">
          {{ buttonLabel }}
        </MoleculeButton>
        <MoleculeButton :url="buttonUrl" :enable-icon-left="false" size="large" class="hidden md:block">
          {{ buttonLabel }}
        </MoleculeButton>
      </div>
    </div>
    <div class="pb-4 sm:pb-6 border-b border-app-primary-grey--black-squeeze">
      <MoleculeDiscoveryCarousel :items="items" :slides-visible="3" />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  items: { type: Array as PropType<any[]>, required: true },
  title: { type: String, required: false, default: undefined },
  buttonLabel: { type: String, required: false, default: undefined },
  buttonUrl: { type: String, required: false, default: undefined },
  colorTheme: { type: String, required: false, default: undefined },
})
</script>
